import React from 'react'
import cx from 'classnames'

import { Alert } from 'components/shared/Alert/Alert'

import styles from './ActionAlert.module.scss'

export const ActionAlert = ({
  buttonColor = 'primary',
  buttonLabel,
  buttonSize = 'small',
  buttonVariant = 'filled',
  className,
  message,
  variant,
  onAction,
  isInitialised,
}) => {
  return (
    <Alert
      className={cx(styles.alert, { [className]: Boolean(className) })}
      {...{
        buttonColor,
        buttonLabel,
        buttonSize,
        buttonVariant,
        message,
        variant,
        onAction,
        isInitialised,
      }}
    >
      <Alert.Message />
      <Alert.ActionButton />
    </Alert>
  )
}
